export default {"src":"/_next/static/media/berry-street-logo-green.6ba29137.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};